import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from '../security/services/security.service';

@Injectable()
export class AuthGuardAdminService implements CanActivate, CanActivateChild {
  constructor(public router: Router, private securityService: SecurityService) {}
  private navigateToHomePage(): void {
    this.router.navigate(['']);
  }

  private isAdmin(): Observable<boolean> {
    const response = this.securityService.isAdmin();
    response.subscribe(
      (res) => {
        if (!res) {
          this.navigateToHomePage();
        }
      },
      (error) => {
        console.error(error);
        this.navigateToHomePage();
      }
    );
    return response;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.isAdmin();
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    return this.isAdmin();
  }
}